import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../MetricLoader';
import DeltaMetric from '../DeltaMetric';
import { tags_educator } from '../../../utils/query-helpers';

export default function TotalYear(props) {
  const { network, schoolStart, schoolEnd, titleOnly, name = 'Total' } = props;

  const allSchools = useConnect('site.find', {
    where: {
      eager: {
        // $aggregations: [
        //   {
        //     type: 'count',
        //     alias: 'numberOfEducators',
        //     relation: 'roles.user',
        //     $where: {
        //       ...tags_educator(),
        //       // 'networks.id': network?.id
        //       networkId: network?.id,
        //       createdAt: {
        //         $lte: schoolEnd
        //       }
        //     }
        //   }
        // ],
        $where: {
          // createdAt: {
          //   $lte: schoolEnd
          // }
          users: {
            $where: {
              ...tags_educator(),
              // 'networks.id': network?.id
              networkId: network?.id,
              createdAt: {
                $lte: schoolEnd
              }
            }
          }
        },
        // $having: {
        //   numberOfEducators: {
        //     $gt: 0
        //   }
        // }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  // const newSchools = useConnect('site.find', {
  //   where: {
  //     eager: {
  //       $aggregations: [
  //         {
  //           type: 'count',
  //           alias: 'numberOfEducators',
  //           relation: 'users',
  //           $where: {
  //             ...tags_educator(),
  //             // 'networks.id': network?.id
  //             networkId: network?.id,
  //             createdAt: {
  //               $lte: schoolEnd,
  //               $gte: schoolStart
  //             }
  //           }
  //         }
  //       ],
  //       $where: {
  //         numberOfEducators: {
  //           $gt: 0
  //         },
  //         // createdAt: {
  //         //   $lte: schoolEnd,
  //         //   $gte: schoolStart
  //         // }
  //       }
  //     }
  //   },
  //   pagination: {
  //     pageSize: 1
  //   }
  // });

  const previousSchools = useConnect('site.find', {
    where: {
      eager: {
        // $aggregations: [
        //   {
        //     type: 'count',
        //     alias: 'numberOfEducators',
        //     relation: 'users',
        //     $where: {
        //       ...tags_educator(),
        //       // 'networks.id': network?.id
        //       networkId: network?.id,
        //       createdAt: {
        //         $lte: schoolStart
        //       }
        //     }
        //   }
        // ],
        $where: {
          // createdAt: {
          //   $lte: schoolEnd,
          //   $gte: schoolStart
          // }
          users: {
            $where: {
              ...tags_educator(),
              // 'networks.id': network?.id
              networkId: network?.id,
              createdAt: {
                $lte: schoolStart
              }
            }
          }
        },
        // $having: {
        //   numberOfEducators: {
        //     $gte: 1
        //   }
        // }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  if (
    allSchools.state === PayloadStates.FETCHING ||
    previousSchools.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name={name}
      />
    );
  }

  return (
    <DeltaMetric
      name={name}
      value={allSchools.meta.totalCount}
      delta={allSchools.meta.totalCount - previousSchools.meta.totalCount}
      titleOnly={titleOnly}
    />
  );
}
